import { INIT_MAIN, UPDATE_CONFIG_SUCCESS } from '../actionTypes';

export default function matrix(state, action) {
  const { type, payload } = action;
  const defaultState = state || '';

  switch (type) {
    case INIT_MAIN:
    case UPDATE_CONFIG_SUCCESS:
      return payload.matrix || defaultState;
    default:
      return defaultState;
  }
}
